/**
 * @file        src/api/brands.js
 * @description The tenant's brand registry, fetched once and shared by every
 *              brand dropdown/filter. Brands are DATA (any number per tenant,
 *              3-char codes) — no component may hardcode a brand list.
 * @author      Kinetika Labs
 * @created     2026-08-03
 * @changelog
 *   - 2026-08-03 Claude — Initial (registry-driven brands).
 */
import { useQuery } from '@tanstack/react-query';
import { get } from './client';
import { qk } from './queryKeys';

/** Active brands of the CURRENT tenant (console host). */
export function useBrands() {
  const q = useQuery({
    queryKey: qk.brands.list,
    queryFn: () => get('/brands').then((r) => r.data),
    staleTime: 5 * 60 * 1000,
  });
  const brands = q.data || [];
  return {
    ...q,
    brands,
    options: brands.map((b) => ({ value: b.code, label: b.name })),
    labelOf: (code) => brands.find((b) => b.code === code)?.name || code || '—',
  };
}
